<template>
  <form
    @submit.prevent="onSave">
    <fixed-header id="sticky-header">
      <div class="row form-header py-2">
        <div class="col-sm-4 col-xl-4 m-auto">
          <a class="h6" href="javascript:void(0)"
            @click="onView"
          >
            <i class="uil-arrow-left"></i> {{$t('common.back_to')}} {{$t('role.singular')}}
          </a>
        </div>
        <div class="col-sm-8 col-xl-8 text-sm-right">
          <div class="btn-group d-sm-inline-block">
              <button 
                type="submit" 
                class="btn2 btn2-primary btn-sm"
              ><i class="uil uil-edit mr-1"></i>{{$t('common.save')}}</button>
          </div>
        </div>
        
      </div>
    </fixed-header>

    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if='errorMessage'>
      {{errorMessage}}
    </div>

    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">{{$t('industry.form.information')}}</h4>
            <p class="sub-header"></p>
            <div class="row">
              <div class="form-group  col-md-6">
                <TextField 
                  :placeholder="$t('industry.form.name.label')"
                  :label="$t('industry.form.name.label')"
                  v-model="model.name"
                  :error="$v.model.name.$error"
                  :errorMessage="$v.model.name.errorMessage"
                />
              </div>
              <div class="form-group col-md-6">
                <div>
                  <b-form-checkbox 
                    v-model="administration" 
                    name="check-button" 
                    switch
                    >
                    Administration
                  </b-form-checkbox>
                  <div v-if="administration" class="ml-3">
                    <b-form-checkbox 
                      v-model="user_management" 
                      name="check-button" 
                      switch
                      class="mt-3"
                      >
                      User Management
                    </b-form-checkbox>
                    <div class="form-group ml-3" v-if="user_management">
                      <b-form-checkbox
                        v-for="(action, key) in actions"
                        v-model="action.value" 
                        name="check-button" 
                        switch
                        :key="key"
                        >
                        {{action.name}}
                      </b-form-checkbox>
                    </div>
                    <b-form-checkbox 
                      v-model="email_template" 
                      name="check-button" 
                      switch
                      class="mt-3"
                      >
                      Email Template
                    </b-form-checkbox>
                    <div class="form-group ml-3" v-if="email_template">
                      <b-form-checkbox
                        v-for="(action, key) in actions"
                        v-model="action.value" 
                        name="check-button" 
                        switch
                        :key="key"
                        >
                        {{action.name}}
                      </b-form-checkbox>
                    </div>
                    <b-form-checkbox 
                      v-model="source_companies" 
                      name="check-button" 
                      switch
                      class="mt-3"
                      >
                      Source Companies
                    </b-form-checkbox>
                    <div class="form-group ml-3" v-if="source_companies">
                      <b-form-checkbox
                        v-for="(action, key) in view_action"
                        v-model="action.value" 
                        name="check-button" 
                        switch
                        :key="key"
                        >
                        {{action.name}}
                      </b-form-checkbox>
                    </div>
                    <b-form-checkbox 
                      v-model="staging_job" 
                      name="check-button" 
                      switch
                      class="mt-3"
                      >
                      Staging Job
                    </b-form-checkbox>
                    <div class="form-group ml-3" v-if="staging_job">
                      <b-form-checkbox
                        v-for="(action, key) in view_action"
                        v-model="action.value" 
                        name="check-button" 
                        switch
                        :key="key"
                        >
                        {{action.name}}
                      </b-form-checkbox>
                    </div>
                    <b-form-checkbox 
                      v-model="webcrawler_log" 
                      name="check-button" 
                      switch
                      class="mt-3"
                      >
                      Webcrawler Log
                    </b-form-checkbox>
                    <div class="form-group ml-3" v-if="webcrawler_log">
                      <b-form-checkbox
                        v-for="(action, key) in view_action"
                        v-model="action.value" 
                        name="check-button" 
                        switch
                        :key="key"
                        >
                        {{action.name}}
                      </b-form-checkbox>
                    </div>
                    <b-form-checkbox 
                      v-model="role" 
                      name="check-button" 
                      switch
                      class="mt-3"
                      >
                      Role
                    </b-form-checkbox>
                    <div class="form-group ml-3" v-if="role">
                      <b-form-checkbox
                        v-for="(action, key) in actions"
                        v-model="action.value" 
                        name="check-button" 
                        switch
                        :key="key"
                        >
                        {{action.name}}
                      </b-form-checkbox>
                    </div>
                  </div>
                </div>
                <div>
                  <b-form-checkbox 
                    v-model="master_file" 
                    name="check-button" 
                    switch
                    >
                    Master File
                  </b-form-checkbox>
                  <div v-if="master_file" class="ml-3">
                    <b-form-checkbox 
                      v-model="webcrawler" 
                      name="check-button" 
                      switch
                      class="mt-3"
                      >
                      Webcrawler
                    </b-form-checkbox>
                    <div class="form-group ml-3" v-if="webcrawler">
                      <b-form-checkbox
                        v-for="(action, key) in actions"
                        v-model="action.value" 
                        name="check-button" 
                        switch
                        :key="key"
                        >
                        {{action.name}}
                      </b-form-checkbox>
                    </div>
                    <b-form-checkbox 
                      v-model="industry" 
                      name="check-button" 
                      switch
                      class="mt-3"
                      >
                      Industries
                    </b-form-checkbox>
                    <div class="form-group ml-3" v-if="industry">
                      <b-form-checkbox
                        v-for="(action, key) in actions"
                        v-model="action.value" 
                        name="check-button" 
                        switch
                        :key="key"
                        >
                        {{action.name}}
                      </b-form-checkbox>
                    </div>
                    <b-form-checkbox 
                      v-model="functions" 
                      name="check-button" 
                      switch
                      class="mt-3"
                      >
                      Functions
                    </b-form-checkbox>
                    <div class="form-group ml-3" v-if="functions">
                      <b-form-checkbox
                        v-for="(action, key) in actions"
                        v-model="action.value" 
                        name="check-button" 
                        switch
                        :key="key"
                        >
                        {{action.name}}
                      </b-form-checkbox>
                    </div>
                    <b-form-checkbox 
                      v-model="brand" 
                      name="check-button" 
                      switch
                      class="mt-3"
                      >
                      Brands
                    </b-form-checkbox>
                    <div class="form-group ml-3" v-if="brand">
                      <b-form-checkbox
                        v-for="(action, key) in actions"
                        v-model="action.value" 
                        name="check-button" 
                        switch
                        :key="key"
                        >
                        {{action.name}}
                      </b-form-checkbox>
                    </div>
                    <b-form-checkbox 
                      v-model="currency" 
                      name="check-button" 
                      switch
                      class="mt-3"
                      >
                      Currencies
                    </b-form-checkbox>
                    <div class="form-group ml-3" v-if="currency">
                      <b-form-checkbox
                        v-for="(action, key) in actions"
                        v-model="action.value" 
                        name="check-button" 
                        switch
                        :key="key"
                        >
                        {{action.name}}
                      </b-form-checkbox>
                    </div>
                    <b-form-checkbox 
                      v-model="source_candidates" 
                      name="check-button" 
                      switch
                      class="mt-3"
                      >
                      Source Candidates
                    </b-form-checkbox>
                    <div class="form-group ml-3" v-if="source_candidates">
                      <b-form-checkbox
                        v-for="(action, key) in actions"
                        v-model="action.value" 
                        name="check-button" 
                        switch
                        :key="key"
                        >
                        {{action.name}}
                      </b-form-checkbox>
                    </div>
                  </div>
                </div>
                <div>
                  <b-form-checkbox 
                    v-model="job" 
                    name="check-button" 
                    switch
                    >
                    Jobs
                  </b-form-checkbox>
                  <div class="form-group ml-3" v-if="job">
                    <b-form-checkbox
                      v-for="(action, key) in job_actions"
                      v-model="action.value" 
                      name="check-button" 
                      switch
                      :key="key"
                      >
                      {{action.name}}
                    </b-form-checkbox>
                  </div>
                </div>
                <div>
                  <b-form-checkbox 
                    v-model="candidate" 
                    name="check-button" 
                    switch
                    >
                    Candidates
                  </b-form-checkbox>
                  <div class="form-group ml-3" v-if="candidate">
                    <b-form-checkbox
                      v-for="(action, key) in actions"
                      v-model="action.value" 
                      name="check-button" 
                      switch
                      :key="key"
                      >
                      {{action.name}}
                    </b-form-checkbox>
                  </div>
                </div>
                <div>
                  <b-form-checkbox 
                    v-model="application" 
                    name="check-button" 
                    switch
                    >
                    Applications
                  </b-form-checkbox>
                  <div class="form-group ml-3" v-if="application">
                    <b-form-checkbox
                      v-for="(action, key) in actions"
                      v-model="action.value" 
                      name="check-button" 
                      switch
                      :key="key"
                      >
                      {{action.name}}
                    </b-form-checkbox>
                  </div>
                </div>
                <div>
                  <b-form-checkbox 
                    v-model="company" 
                    name="check-button" 
                    switch
                    >
                    Companies
                  </b-form-checkbox>
                  <div class="form-group ml-3" v-if="company">
                    <b-form-checkbox
                      v-for="(action, key) in actions"
                      v-model="action.value" 
                      name="check-button" 
                      switch
                      :key="key"
                      >
                      {{action.name}}
                    </b-form-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import FixedHeader from 'vue-fixed-header'
import TextField from '@components/form/textfield.vue'
import { required } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import  FormMixin from '@mixins/form'


export default {
  mixins: [FormMixin],
  data(){
    return {
      model:{
        name: '',
        remarks: '',
      },
      fullWidth:document.getElementsByClassName('content-page').item(0).clientWidth,
      actions: [
        { name: 'Index', value: false },
        { name: 'View', value: false },
        { name: 'Create', value: false },
        { name: 'Edit', value: false }
      ],
      job_actions: [
        { name: 'Index', value: false },
        { name: 'View', value: false },
        { name: 'Create', value: false },
        { name: 'Generate Link', value: false },
        { name: 'Deactivate', value: false },
        { name: 'Submit Candidate', value: false },
        { name: 'Post', value: false },
        { name: 'Unpost', value: false }
      ],
      view_action: [
        { name: 'Index', value: false }
      ],
      administration: true,
      user_management: false,
      email_template: false,
      source_companies: false,
      staging_job: false,
      webcrawler_log: false,
      role: false,
      master_file: true,
      webcrawler: false,
      industry: false,
      functions: false,
      brand: false,
      currency: false,
      source_candidates: false,
      job: true,
      candidate: true,
      application: true,
      company: true,
      calendar: false
    }
  },
  validations: {
    model:{
      name: { required }
    }
  },
  components:{FixedHeader, TextField},
  mounted(){
    window.addEventListener('resize', this.handleResize)
  },
  created(){
    this.handleResize()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapActions('industry', ['create', 'update', 'find']),
    onView() {
      if(this.$route.query.id){
        this.$router.push('/administration/role/view?id=' + this.$route.query.id)
      }else{
        this.$router.push('/administration/role')
      }
    },
    selectedCheckbox (selected) {
      console.log(selected)
      this.administration = selected
    },
    onSave() {

      if (this.validateForm()) {
				this.toggleLoading()
				return;
			}
      
      this[!this.model.id ? 'create' : 'update'](this.model)
      .then(()=> {
        this.toggleLoading()
         this.$router.push('/master_files/industry')
      })
      .catch((err) => {
        this.toggleLoading()

        Object.keys(err.response.data).forEach(key => {
          if(this.$v.model[key]) this.$v.model[key].errorMessage = err.response.data[key]
        })

        this.setError(err.response.data.msg)

      })
    },
    handleResize () {
      let header = document.getElementById('sticky-header');
      this.fullWidth = document.getElementsByClassName('content-page').item(0).clientWidth

      if(header){
        header.style.width = this.fullWidth + 'px'
      }
    },
    onCancel() {
      this.$router.push('/company')
    }
  },
  beforeMount() {
    let id = this.$route.query.id
    if(id){
      this.find({
        id:id
      }).then(data => {
        this.model.name = data.data.name
        this.model.remarks = data.data.remarks
        this.model.id = data.data._id
      })
    }
  }
}
</script>

